import { z } from 'zod';

import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { ImageFit } from '../../themes/theme';
import { WidgetType } from '../../utils/widgetsUtils';

export enum FeedbackIconsType {
  Regular = 'regular',
  Like = 'like',
  Face = 'face'
}

export const InfoHotspotContentSchema = z.object({
  title: z.string(),
  content: z.string().optional(),
  src: z.string().optional(),
  alt: z.string().optional(),
  infoDescription: z.string()
});

const InfoHotspotSchema = z.object({
  id: z.string(),
  isNew: z.boolean(),
  type: z.string(),
  position: z.object({
    top: z.string(),
    left: z.string()
  }),
  text: InfoHotspotContentSchema,
  image: InfoHotspotContentSchema,
  audio: InfoHotspotContentSchema,
  link: InfoHotspotContentSchema,
  embed: InfoHotspotContentSchema
});

const AnswerHotspotSchema = z.object({
  id: z.string(),
  isNew: z.boolean(),
  position: z.object({
    top: z.string(),
    left: z.string()
  }),
  infoDescription: z.string(),
  answerText: z.string()
});

export const HotspotQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.HotspotQuestion).extend({
  saveAnswers: z.boolean(),
  children: z.array(z.string()).optional(), // `children` is optional because it is not used in the Hotspot's `create` function
  imageSrc: z.string(),
  imageFit: z.nativeEnum(ImageFit),
  imageDescription: z.string(),
  iconStyle: z.string(),
  withNumbering: z.boolean(),
  withZoom: z.boolean(),
  infoHotspots: z.record(z.string(), InfoHotspotSchema),
  infoHotspotsOrder: z.array(z.string()),
  answerHotspots: z.record(z.string(), AnswerHotspotSchema),
  answerHotspotsOrder: z.array(z.string()),
  feedbackIconsType: z.nativeEnum(FeedbackIconsType),
  showShortFeedbackText: z.boolean(),
  correctAnswerFeedback: z.string(),
  wrongAnswerFeedback: z.string(),
  style: z
    .object({
      infoColor: z.string().nullable().optional(),
      answerColor: z.string().nullable().optional()
    })
    .optional()
});

export type HotspotQuestionWidgetStaticSchemaType = z.infer<typeof HotspotQuestionWidgetStaticSchema>;
